import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivityListingComponent } from './activity-listing.component';
import { KIconModule } from 'ng-k-icon';
import { KButtonModule } from 'ng-k-button';
import { KDataVisualizationModule } from 'ng-k-data-visualization';
import { KModalModule } from 'ng-k-modal';
import { KNotificationsModule } from 'ng-k-notifications';
import { CustomBreadcrumbModule } from 'src/app/pages/common/custom-breadcrumb/custom-breadcrumb.module';

@NgModule({
  declarations: [
    ActivityListingComponent
  ],
  imports: [
    CommonModule,
    KIconModule,
    KButtonModule,
    KDataVisualizationModule,
    KModalModule,
    KNotificationsModule,
    CustomBreadcrumbModule
  ]
})
export class ActivityListingModule { }
